/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as XpLabFeedbackRouteImport } from './routes/xp-lab-feedback'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UsingAiWithoutOutsourcingJudgmentRouteImport } from './routes/using-ai-without-outsourcing-judgment'
import { Route as UserAreaRouteImport } from './routes/user-area'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as TakeHomeAssignmentsRouteImport } from './routes/take-home-assignments'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as AssignmentsRouteImport } from './routes/assignments'
import { Route as AnalyticalWorkflowRouteImport } from './routes/analytical-workflow'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UpdatesIndexRouteImport } from './routes/updates/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as UpdatesSlugRouteImport } from './routes/updates/$slug'
import { Route as SubmissionSlugRouteImport } from './routes/submission.$slug'
import { Route as PartnerSettingsRouteImport } from './routes/partner/settings'
import { Route as PartnerDashboardRouteImport } from './routes/partner/dashboard'
import { Route as MySharesChallengeSlugRouteImport } from './routes/my-shares.$challengeSlug'
import { Route as ChallengesCompletedRouteImport } from './routes/challenges/completed'
import { Route as ChallengesAvailableRouteImport } from './routes/challenges/available'
import { Route as ChallengeSlugRouteImport } from './routes/challenge.$slug'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthLinkedinRouteImport } from './routes/auth/linkedin'
import { Route as AuthInviteRouteImport } from './routes/auth/invite'
import { Route as AuthGoogleRouteImport } from './routes/auth/google'
import { Route as AdminWaitingListRouteImport } from './routes/admin/waiting-list'
import { Route as AdminTasksRouteImport } from './routes/admin/tasks'
import { Route as AdminStatisticsRouteImport } from './routes/admin/statistics'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminInvitationsRouteImport } from './routes/admin/invitations'
import { Route as LangXpLabFeedbackRouteImport } from './routes/$lang/xp-lab-feedback'
import { Route as LangUsingAiWithoutOutsourcingJudgmentRouteImport } from './routes/$lang/using-ai-without-outsourcing-judgment'
import { Route as LangTermsOfServiceRouteImport } from './routes/$lang/terms-of-service'
import { Route as LangTakeHomeAssignmentsRouteImport } from './routes/$lang/take-home-assignments'
import { Route as LangPrivacyPolicyRouteImport } from './routes/$lang/privacy-policy'
import { Route as LangFaqRouteImport } from './routes/$lang/faq'
import { Route as LangAnalyticalWorkflowRouteImport } from './routes/$lang/analytical-workflow'
import { Route as LangAboutRouteImport } from './routes/$lang/about'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminOrganizationsIndexRouteImport } from './routes/admin/organizations/index'
import { Route as AdminChallengesIndexRouteImport } from './routes/admin/challenges/index'
import { Route as PartnerCIdRouteImport } from './routes/partner/c.$id'
import { Route as AdminUsersIdRouteImport } from './routes/admin/users/$id'
import { Route as AdminChallengesSlugRouteImport } from './routes/admin/challenges/$slug'
import { Route as AdminOrganizationsAssignmentsOrganizationIdRouteImport } from './routes/admin/organizations/assignments.$organizationId'

const XpLabFeedbackRoute = XpLabFeedbackRouteImport.update({
  id: '/xp-lab-feedback',
  path: '/xp-lab-feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const UsingAiWithoutOutsourcingJudgmentRoute =
  UsingAiWithoutOutsourcingJudgmentRouteImport.update({
    id: '/using-ai-without-outsourcing-judgment',
    path: '/using-ai-without-outsourcing-judgment',
    getParentRoute: () => rootRouteImport,
  } as any)
const UserAreaRoute = UserAreaRouteImport.update({
  id: '/user-area',
  path: '/user-area',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const TakeHomeAssignmentsRoute = TakeHomeAssignmentsRouteImport.update({
  id: '/take-home-assignments',
  path: '/take-home-assignments',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const AssignmentsRoute = AssignmentsRouteImport.update({
  id: '/assignments',
  path: '/assignments',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticalWorkflowRoute = AnalyticalWorkflowRouteImport.update({
  id: '/analytical-workflow',
  path: '/analytical-workflow',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const LangRoute = LangRouteImport.update({
  id: '/$lang',
  path: '/$lang',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UpdatesIndexRoute = UpdatesIndexRouteImport.update({
  id: '/updates/',
  path: '/updates/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const LangIndexRoute = LangIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LangRoute,
} as any)
const UpdatesSlugRoute = UpdatesSlugRouteImport.update({
  id: '/updates/$slug',
  path: '/updates/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const SubmissionSlugRoute = SubmissionSlugRouteImport.update({
  id: '/submission/$slug',
  path: '/submission/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerSettingsRoute = PartnerSettingsRouteImport.update({
  id: '/partner/settings',
  path: '/partner/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerDashboardRoute = PartnerDashboardRouteImport.update({
  id: '/partner/dashboard',
  path: '/partner/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const MySharesChallengeSlugRoute = MySharesChallengeSlugRouteImport.update({
  id: '/my-shares/$challengeSlug',
  path: '/my-shares/$challengeSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const ChallengesCompletedRoute = ChallengesCompletedRouteImport.update({
  id: '/challenges/completed',
  path: '/challenges/completed',
  getParentRoute: () => rootRouteImport,
} as any)
const ChallengesAvailableRoute = ChallengesAvailableRouteImport.update({
  id: '/challenges/available',
  path: '/challenges/available',
  getParentRoute: () => rootRouteImport,
} as any)
const ChallengeSlugRoute = ChallengeSlugRouteImport.update({
  id: '/challenge/$slug',
  path: '/challenge/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/auth/signup',
  path: '/auth/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLinkedinRoute = AuthLinkedinRouteImport.update({
  id: '/auth/linkedin',
  path: '/auth/linkedin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthInviteRoute = AuthInviteRouteImport.update({
  id: '/auth/invite',
  path: '/auth/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthGoogleRoute = AuthGoogleRouteImport.update({
  id: '/auth/google',
  path: '/auth/google',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWaitingListRoute = AdminWaitingListRouteImport.update({
  id: '/waiting-list',
  path: '/waiting-list',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTasksRoute = AdminTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStatisticsRoute = AdminStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvitationsRoute = AdminInvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => AdminRoute,
} as any)
const LangXpLabFeedbackRoute = LangXpLabFeedbackRouteImport.update({
  id: '/xp-lab-feedback',
  path: '/xp-lab-feedback',
  getParentRoute: () => LangRoute,
} as any)
const LangUsingAiWithoutOutsourcingJudgmentRoute =
  LangUsingAiWithoutOutsourcingJudgmentRouteImport.update({
    id: '/using-ai-without-outsourcing-judgment',
    path: '/using-ai-without-outsourcing-judgment',
    getParentRoute: () => LangRoute,
  } as any)
const LangTermsOfServiceRoute = LangTermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => LangRoute,
} as any)
const LangTakeHomeAssignmentsRoute = LangTakeHomeAssignmentsRouteImport.update({
  id: '/take-home-assignments',
  path: '/take-home-assignments',
  getParentRoute: () => LangRoute,
} as any)
const LangPrivacyPolicyRoute = LangPrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => LangRoute,
} as any)
const LangFaqRoute = LangFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => LangRoute,
} as any)
const LangAnalyticalWorkflowRoute = LangAnalyticalWorkflowRouteImport.update({
  id: '/analytical-workflow',
  path: '/analytical-workflow',
  getParentRoute: () => LangRoute,
} as any)
const LangAboutRoute = LangAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => LangRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsIndexRoute = AdminOrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminChallengesIndexRoute = AdminChallengesIndexRouteImport.update({
  id: '/challenges/',
  path: '/challenges/',
  getParentRoute: () => AdminRoute,
} as any)
const PartnerCIdRoute = PartnerCIdRouteImport.update({
  id: '/partner/c/$id',
  path: '/partner/c/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIdRoute = AdminUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminChallengesSlugRoute = AdminChallengesSlugRouteImport.update({
  id: '/challenges/$slug',
  path: '/challenges/$slug',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsAssignmentsOrganizationIdRoute =
  AdminOrganizationsAssignmentsOrganizationIdRouteImport.update({
    id: '/organizations/assignments/$organizationId',
    path: '/organizations/assignments/$organizationId',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteWithChildren
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/analytical-workflow': typeof AnalyticalWorkflowRoute
  '/assignments': typeof AssignmentsRoute
  '/faq': typeof FaqRoute
  '/invite': typeof InviteRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/take-home-assignments': typeof TakeHomeAssignmentsRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/user-area': typeof UserAreaRoute
  '/using-ai-without-outsourcing-judgment': typeof UsingAiWithoutOutsourcingJudgmentRoute
  '/verify-email': typeof VerifyEmailRoute
  '/xp-lab-feedback': typeof XpLabFeedbackRoute
  '/$lang/about': typeof LangAboutRoute
  '/$lang/analytical-workflow': typeof LangAnalyticalWorkflowRoute
  '/$lang/faq': typeof LangFaqRoute
  '/$lang/privacy-policy': typeof LangPrivacyPolicyRoute
  '/$lang/take-home-assignments': typeof LangTakeHomeAssignmentsRoute
  '/$lang/terms-of-service': typeof LangTermsOfServiceRoute
  '/$lang/using-ai-without-outsourcing-judgment': typeof LangUsingAiWithoutOutsourcingJudgmentRoute
  '/$lang/xp-lab-feedback': typeof LangXpLabFeedbackRoute
  '/admin/invitations': typeof AdminInvitationsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/statistics': typeof AdminStatisticsRoute
  '/admin/tasks': typeof AdminTasksRoute
  '/admin/waiting-list': typeof AdminWaitingListRoute
  '/auth/google': typeof AuthGoogleRoute
  '/auth/invite': typeof AuthInviteRoute
  '/auth/linkedin': typeof AuthLinkedinRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/signup': typeof AuthSignupRoute
  '/challenge/$slug': typeof ChallengeSlugRoute
  '/challenges/available': typeof ChallengesAvailableRoute
  '/challenges/completed': typeof ChallengesCompletedRoute
  '/my-shares/$challengeSlug': typeof MySharesChallengeSlugRoute
  '/partner/dashboard': typeof PartnerDashboardRoute
  '/partner/settings': typeof PartnerSettingsRoute
  '/submission/$slug': typeof SubmissionSlugRoute
  '/updates/$slug': typeof UpdatesSlugRoute
  '/$lang/': typeof LangIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/updates': typeof UpdatesIndexRoute
  '/admin/challenges/$slug': typeof AdminChallengesSlugRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/partner/c/$id': typeof PartnerCIdRoute
  '/admin/challenges': typeof AdminChallengesIndexRoute
  '/admin/organizations': typeof AdminOrganizationsIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/admin/organizations/assignments/$organizationId': typeof AdminOrganizationsAssignmentsOrganizationIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/analytical-workflow': typeof AnalyticalWorkflowRoute
  '/assignments': typeof AssignmentsRoute
  '/faq': typeof FaqRoute
  '/invite': typeof InviteRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/take-home-assignments': typeof TakeHomeAssignmentsRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/user-area': typeof UserAreaRoute
  '/using-ai-without-outsourcing-judgment': typeof UsingAiWithoutOutsourcingJudgmentRoute
  '/verify-email': typeof VerifyEmailRoute
  '/xp-lab-feedback': typeof XpLabFeedbackRoute
  '/$lang/about': typeof LangAboutRoute
  '/$lang/analytical-workflow': typeof LangAnalyticalWorkflowRoute
  '/$lang/faq': typeof LangFaqRoute
  '/$lang/privacy-policy': typeof LangPrivacyPolicyRoute
  '/$lang/take-home-assignments': typeof LangTakeHomeAssignmentsRoute
  '/$lang/terms-of-service': typeof LangTermsOfServiceRoute
  '/$lang/using-ai-without-outsourcing-judgment': typeof LangUsingAiWithoutOutsourcingJudgmentRoute
  '/$lang/xp-lab-feedback': typeof LangXpLabFeedbackRoute
  '/admin/invitations': typeof AdminInvitationsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/statistics': typeof AdminStatisticsRoute
  '/admin/tasks': typeof AdminTasksRoute
  '/admin/waiting-list': typeof AdminWaitingListRoute
  '/auth/google': typeof AuthGoogleRoute
  '/auth/invite': typeof AuthInviteRoute
  '/auth/linkedin': typeof AuthLinkedinRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/signup': typeof AuthSignupRoute
  '/challenge/$slug': typeof ChallengeSlugRoute
  '/challenges/available': typeof ChallengesAvailableRoute
  '/challenges/completed': typeof ChallengesCompletedRoute
  '/my-shares/$challengeSlug': typeof MySharesChallengeSlugRoute
  '/partner/dashboard': typeof PartnerDashboardRoute
  '/partner/settings': typeof PartnerSettingsRoute
  '/submission/$slug': typeof SubmissionSlugRoute
  '/updates/$slug': typeof UpdatesSlugRoute
  '/$lang': typeof LangIndexRoute
  '/admin': typeof AdminIndexRoute
  '/updates': typeof UpdatesIndexRoute
  '/admin/challenges/$slug': typeof AdminChallengesSlugRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/partner/c/$id': typeof PartnerCIdRoute
  '/admin/challenges': typeof AdminChallengesIndexRoute
  '/admin/organizations': typeof AdminOrganizationsIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/admin/organizations/assignments/$organizationId': typeof AdminOrganizationsAssignmentsOrganizationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteWithChildren
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/analytical-workflow': typeof AnalyticalWorkflowRoute
  '/assignments': typeof AssignmentsRoute
  '/faq': typeof FaqRoute
  '/invite': typeof InviteRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/take-home-assignments': typeof TakeHomeAssignmentsRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/user-area': typeof UserAreaRoute
  '/using-ai-without-outsourcing-judgment': typeof UsingAiWithoutOutsourcingJudgmentRoute
  '/verify-email': typeof VerifyEmailRoute
  '/xp-lab-feedback': typeof XpLabFeedbackRoute
  '/$lang/about': typeof LangAboutRoute
  '/$lang/analytical-workflow': typeof LangAnalyticalWorkflowRoute
  '/$lang/faq': typeof LangFaqRoute
  '/$lang/privacy-policy': typeof LangPrivacyPolicyRoute
  '/$lang/take-home-assignments': typeof LangTakeHomeAssignmentsRoute
  '/$lang/terms-of-service': typeof LangTermsOfServiceRoute
  '/$lang/using-ai-without-outsourcing-judgment': typeof LangUsingAiWithoutOutsourcingJudgmentRoute
  '/$lang/xp-lab-feedback': typeof LangXpLabFeedbackRoute
  '/admin/invitations': typeof AdminInvitationsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/statistics': typeof AdminStatisticsRoute
  '/admin/tasks': typeof AdminTasksRoute
  '/admin/waiting-list': typeof AdminWaitingListRoute
  '/auth/google': typeof AuthGoogleRoute
  '/auth/invite': typeof AuthInviteRoute
  '/auth/linkedin': typeof AuthLinkedinRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/signup': typeof AuthSignupRoute
  '/challenge/$slug': typeof ChallengeSlugRoute
  '/challenges/available': typeof ChallengesAvailableRoute
  '/challenges/completed': typeof ChallengesCompletedRoute
  '/my-shares/$challengeSlug': typeof MySharesChallengeSlugRoute
  '/partner/dashboard': typeof PartnerDashboardRoute
  '/partner/settings': typeof PartnerSettingsRoute
  '/submission/$slug': typeof SubmissionSlugRoute
  '/updates/$slug': typeof UpdatesSlugRoute
  '/$lang/': typeof LangIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/updates/': typeof UpdatesIndexRoute
  '/admin/challenges/$slug': typeof AdminChallengesSlugRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/partner/c/$id': typeof PartnerCIdRoute
  '/admin/challenges/': typeof AdminChallengesIndexRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/organizations/assignments/$organizationId': typeof AdminOrganizationsAssignmentsOrganizationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$lang'
    | '/about'
    | '/admin'
    | '/analytical-workflow'
    | '/assignments'
    | '/faq'
    | '/invite'
    | '/privacy-policy'
    | '/reset-password'
    | '/take-home-assignments'
    | '/terms-of-service'
    | '/user-area'
    | '/using-ai-without-outsourcing-judgment'
    | '/verify-email'
    | '/xp-lab-feedback'
    | '/$lang/about'
    | '/$lang/analytical-workflow'
    | '/$lang/faq'
    | '/$lang/privacy-policy'
    | '/$lang/take-home-assignments'
    | '/$lang/terms-of-service'
    | '/$lang/using-ai-without-outsourcing-judgment'
    | '/$lang/xp-lab-feedback'
    | '/admin/invitations'
    | '/admin/settings'
    | '/admin/statistics'
    | '/admin/tasks'
    | '/admin/waiting-list'
    | '/auth/google'
    | '/auth/invite'
    | '/auth/linkedin'
    | '/auth/login'
    | '/auth/signup'
    | '/challenge/$slug'
    | '/challenges/available'
    | '/challenges/completed'
    | '/my-shares/$challengeSlug'
    | '/partner/dashboard'
    | '/partner/settings'
    | '/submission/$slug'
    | '/updates/$slug'
    | '/$lang/'
    | '/admin/'
    | '/updates'
    | '/admin/challenges/$slug'
    | '/admin/users/$id'
    | '/partner/c/$id'
    | '/admin/challenges'
    | '/admin/organizations'
    | '/admin/users'
    | '/admin/organizations/assignments/$organizationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/analytical-workflow'
    | '/assignments'
    | '/faq'
    | '/invite'
    | '/privacy-policy'
    | '/reset-password'
    | '/take-home-assignments'
    | '/terms-of-service'
    | '/user-area'
    | '/using-ai-without-outsourcing-judgment'
    | '/verify-email'
    | '/xp-lab-feedback'
    | '/$lang/about'
    | '/$lang/analytical-workflow'
    | '/$lang/faq'
    | '/$lang/privacy-policy'
    | '/$lang/take-home-assignments'
    | '/$lang/terms-of-service'
    | '/$lang/using-ai-without-outsourcing-judgment'
    | '/$lang/xp-lab-feedback'
    | '/admin/invitations'
    | '/admin/settings'
    | '/admin/statistics'
    | '/admin/tasks'
    | '/admin/waiting-list'
    | '/auth/google'
    | '/auth/invite'
    | '/auth/linkedin'
    | '/auth/login'
    | '/auth/signup'
    | '/challenge/$slug'
    | '/challenges/available'
    | '/challenges/completed'
    | '/my-shares/$challengeSlug'
    | '/partner/dashboard'
    | '/partner/settings'
    | '/submission/$slug'
    | '/updates/$slug'
    | '/$lang'
    | '/admin'
    | '/updates'
    | '/admin/challenges/$slug'
    | '/admin/users/$id'
    | '/partner/c/$id'
    | '/admin/challenges'
    | '/admin/organizations'
    | '/admin/users'
    | '/admin/organizations/assignments/$organizationId'
  id:
    | '__root__'
    | '/'
    | '/$lang'
    | '/about'
    | '/admin'
    | '/analytical-workflow'
    | '/assignments'
    | '/faq'
    | '/invite'
    | '/privacy-policy'
    | '/reset-password'
    | '/take-home-assignments'
    | '/terms-of-service'
    | '/user-area'
    | '/using-ai-without-outsourcing-judgment'
    | '/verify-email'
    | '/xp-lab-feedback'
    | '/$lang/about'
    | '/$lang/analytical-workflow'
    | '/$lang/faq'
    | '/$lang/privacy-policy'
    | '/$lang/take-home-assignments'
    | '/$lang/terms-of-service'
    | '/$lang/using-ai-without-outsourcing-judgment'
    | '/$lang/xp-lab-feedback'
    | '/admin/invitations'
    | '/admin/settings'
    | '/admin/statistics'
    | '/admin/tasks'
    | '/admin/waiting-list'
    | '/auth/google'
    | '/auth/invite'
    | '/auth/linkedin'
    | '/auth/login'
    | '/auth/signup'
    | '/challenge/$slug'
    | '/challenges/available'
    | '/challenges/completed'
    | '/my-shares/$challengeSlug'
    | '/partner/dashboard'
    | '/partner/settings'
    | '/submission/$slug'
    | '/updates/$slug'
    | '/$lang/'
    | '/admin/'
    | '/updates/'
    | '/admin/challenges/$slug'
    | '/admin/users/$id'
    | '/partner/c/$id'
    | '/admin/challenges/'
    | '/admin/organizations/'
    | '/admin/users/'
    | '/admin/organizations/assignments/$organizationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LangRoute: typeof LangRouteWithChildren
  AboutRoute: typeof AboutRoute
  AdminRoute: typeof AdminRouteWithChildren
  AnalyticalWorkflowRoute: typeof AnalyticalWorkflowRoute
  AssignmentsRoute: typeof AssignmentsRoute
  FaqRoute: typeof FaqRoute
  InviteRoute: typeof InviteRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TakeHomeAssignmentsRoute: typeof TakeHomeAssignmentsRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  UserAreaRoute: typeof UserAreaRoute
  UsingAiWithoutOutsourcingJudgmentRoute: typeof UsingAiWithoutOutsourcingJudgmentRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  XpLabFeedbackRoute: typeof XpLabFeedbackRoute
  AuthGoogleRoute: typeof AuthGoogleRoute
  AuthInviteRoute: typeof AuthInviteRoute
  AuthLinkedinRoute: typeof AuthLinkedinRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSignupRoute: typeof AuthSignupRoute
  ChallengeSlugRoute: typeof ChallengeSlugRoute
  ChallengesAvailableRoute: typeof ChallengesAvailableRoute
  ChallengesCompletedRoute: typeof ChallengesCompletedRoute
  MySharesChallengeSlugRoute: typeof MySharesChallengeSlugRoute
  PartnerDashboardRoute: typeof PartnerDashboardRoute
  PartnerSettingsRoute: typeof PartnerSettingsRoute
  SubmissionSlugRoute: typeof SubmissionSlugRoute
  UpdatesSlugRoute: typeof UpdatesSlugRoute
  UpdatesIndexRoute: typeof UpdatesIndexRoute
  PartnerCIdRoute: typeof PartnerCIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/xp-lab-feedback': {
      id: '/xp-lab-feedback'
      path: '/xp-lab-feedback'
      fullPath: '/xp-lab-feedback'
      preLoaderRoute: typeof XpLabFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/using-ai-without-outsourcing-judgment': {
      id: '/using-ai-without-outsourcing-judgment'
      path: '/using-ai-without-outsourcing-judgment'
      fullPath: '/using-ai-without-outsourcing-judgment'
      preLoaderRoute: typeof UsingAiWithoutOutsourcingJudgmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-area': {
      id: '/user-area'
      path: '/user-area'
      fullPath: '/user-area'
      preLoaderRoute: typeof UserAreaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/take-home-assignments': {
      id: '/take-home-assignments'
      path: '/take-home-assignments'
      fullPath: '/take-home-assignments'
      preLoaderRoute: typeof TakeHomeAssignmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assignments': {
      id: '/assignments'
      path: '/assignments'
      fullPath: '/assignments'
      preLoaderRoute: typeof AssignmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytical-workflow': {
      id: '/analytical-workflow'
      path: '/analytical-workflow'
      fullPath: '/analytical-workflow'
      preLoaderRoute: typeof AnalyticalWorkflowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang': {
      id: '/$lang'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof LangRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/updates/': {
      id: '/updates/'
      path: '/updates'
      fullPath: '/updates'
      preLoaderRoute: typeof UpdatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/$lang/': {
      id: '/$lang/'
      path: '/'
      fullPath: '/$lang/'
      preLoaderRoute: typeof LangIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/updates/$slug': {
      id: '/updates/$slug'
      path: '/updates/$slug'
      fullPath: '/updates/$slug'
      preLoaderRoute: typeof UpdatesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/submission/$slug': {
      id: '/submission/$slug'
      path: '/submission/$slug'
      fullPath: '/submission/$slug'
      preLoaderRoute: typeof SubmissionSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner/settings': {
      id: '/partner/settings'
      path: '/partner/settings'
      fullPath: '/partner/settings'
      preLoaderRoute: typeof PartnerSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner/dashboard': {
      id: '/partner/dashboard'
      path: '/partner/dashboard'
      fullPath: '/partner/dashboard'
      preLoaderRoute: typeof PartnerDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-shares/$challengeSlug': {
      id: '/my-shares/$challengeSlug'
      path: '/my-shares/$challengeSlug'
      fullPath: '/my-shares/$challengeSlug'
      preLoaderRoute: typeof MySharesChallengeSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/challenges/completed': {
      id: '/challenges/completed'
      path: '/challenges/completed'
      fullPath: '/challenges/completed'
      preLoaderRoute: typeof ChallengesCompletedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/challenges/available': {
      id: '/challenges/available'
      path: '/challenges/available'
      fullPath: '/challenges/available'
      preLoaderRoute: typeof ChallengesAvailableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/challenge/$slug': {
      id: '/challenge/$slug'
      path: '/challenge/$slug'
      fullPath: '/challenge/$slug'
      preLoaderRoute: typeof ChallengeSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/auth/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/linkedin': {
      id: '/auth/linkedin'
      path: '/auth/linkedin'
      fullPath: '/auth/linkedin'
      preLoaderRoute: typeof AuthLinkedinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/invite': {
      id: '/auth/invite'
      path: '/auth/invite'
      fullPath: '/auth/invite'
      preLoaderRoute: typeof AuthInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/google': {
      id: '/auth/google'
      path: '/auth/google'
      fullPath: '/auth/google'
      preLoaderRoute: typeof AuthGoogleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/waiting-list': {
      id: '/admin/waiting-list'
      path: '/waiting-list'
      fullPath: '/admin/waiting-list'
      preLoaderRoute: typeof AdminWaitingListRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tasks': {
      id: '/admin/tasks'
      path: '/tasks'
      fullPath: '/admin/tasks'
      preLoaderRoute: typeof AdminTasksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/statistics': {
      id: '/admin/statistics'
      path: '/statistics'
      fullPath: '/admin/statistics'
      preLoaderRoute: typeof AdminStatisticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/invitations': {
      id: '/admin/invitations'
      path: '/invitations'
      fullPath: '/admin/invitations'
      preLoaderRoute: typeof AdminInvitationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/$lang/xp-lab-feedback': {
      id: '/$lang/xp-lab-feedback'
      path: '/xp-lab-feedback'
      fullPath: '/$lang/xp-lab-feedback'
      preLoaderRoute: typeof LangXpLabFeedbackRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/using-ai-without-outsourcing-judgment': {
      id: '/$lang/using-ai-without-outsourcing-judgment'
      path: '/using-ai-without-outsourcing-judgment'
      fullPath: '/$lang/using-ai-without-outsourcing-judgment'
      preLoaderRoute: typeof LangUsingAiWithoutOutsourcingJudgmentRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/terms-of-service': {
      id: '/$lang/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/$lang/terms-of-service'
      preLoaderRoute: typeof LangTermsOfServiceRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/take-home-assignments': {
      id: '/$lang/take-home-assignments'
      path: '/take-home-assignments'
      fullPath: '/$lang/take-home-assignments'
      preLoaderRoute: typeof LangTakeHomeAssignmentsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/privacy-policy': {
      id: '/$lang/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/$lang/privacy-policy'
      preLoaderRoute: typeof LangPrivacyPolicyRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/faq': {
      id: '/$lang/faq'
      path: '/faq'
      fullPath: '/$lang/faq'
      preLoaderRoute: typeof LangFaqRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/analytical-workflow': {
      id: '/$lang/analytical-workflow'
      path: '/analytical-workflow'
      fullPath: '/$lang/analytical-workflow'
      preLoaderRoute: typeof LangAnalyticalWorkflowRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/about': {
      id: '/$lang/about'
      path: '/about'
      fullPath: '/$lang/about'
      preLoaderRoute: typeof LangAboutRouteImport
      parentRoute: typeof LangRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/organizations/': {
      id: '/admin/organizations/'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminOrganizationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/challenges/': {
      id: '/admin/challenges/'
      path: '/challenges'
      fullPath: '/admin/challenges'
      preLoaderRoute: typeof AdminChallengesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/partner/c/$id': {
      id: '/partner/c/$id'
      path: '/partner/c/$id'
      fullPath: '/partner/c/$id'
      preLoaderRoute: typeof PartnerCIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/$id': {
      id: '/admin/users/$id'
      path: '/users/$id'
      fullPath: '/admin/users/$id'
      preLoaderRoute: typeof AdminUsersIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/challenges/$slug': {
      id: '/admin/challenges/$slug'
      path: '/challenges/$slug'
      fullPath: '/admin/challenges/$slug'
      preLoaderRoute: typeof AdminChallengesSlugRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/organizations/assignments/$organizationId': {
      id: '/admin/organizations/assignments/$organizationId'
      path: '/organizations/assignments/$organizationId'
      fullPath: '/admin/organizations/assignments/$organizationId'
      preLoaderRoute: typeof AdminOrganizationsAssignmentsOrganizationIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface LangRouteChildren {
  LangAboutRoute: typeof LangAboutRoute
  LangAnalyticalWorkflowRoute: typeof LangAnalyticalWorkflowRoute
  LangFaqRoute: typeof LangFaqRoute
  LangPrivacyPolicyRoute: typeof LangPrivacyPolicyRoute
  LangTakeHomeAssignmentsRoute: typeof LangTakeHomeAssignmentsRoute
  LangTermsOfServiceRoute: typeof LangTermsOfServiceRoute
  LangUsingAiWithoutOutsourcingJudgmentRoute: typeof LangUsingAiWithoutOutsourcingJudgmentRoute
  LangXpLabFeedbackRoute: typeof LangXpLabFeedbackRoute
  LangIndexRoute: typeof LangIndexRoute
}

const LangRouteChildren: LangRouteChildren = {
  LangAboutRoute: LangAboutRoute,
  LangAnalyticalWorkflowRoute: LangAnalyticalWorkflowRoute,
  LangFaqRoute: LangFaqRoute,
  LangPrivacyPolicyRoute: LangPrivacyPolicyRoute,
  LangTakeHomeAssignmentsRoute: LangTakeHomeAssignmentsRoute,
  LangTermsOfServiceRoute: LangTermsOfServiceRoute,
  LangUsingAiWithoutOutsourcingJudgmentRoute:
    LangUsingAiWithoutOutsourcingJudgmentRoute,
  LangXpLabFeedbackRoute: LangXpLabFeedbackRoute,
  LangIndexRoute: LangIndexRoute,
}

const LangRouteWithChildren = LangRoute._addFileChildren(LangRouteChildren)

interface AdminRouteChildren {
  AdminInvitationsRoute: typeof AdminInvitationsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStatisticsRoute: typeof AdminStatisticsRoute
  AdminTasksRoute: typeof AdminTasksRoute
  AdminWaitingListRoute: typeof AdminWaitingListRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminChallengesSlugRoute: typeof AdminChallengesSlugRoute
  AdminUsersIdRoute: typeof AdminUsersIdRoute
  AdminChallengesIndexRoute: typeof AdminChallengesIndexRoute
  AdminOrganizationsIndexRoute: typeof AdminOrganizationsIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminOrganizationsAssignmentsOrganizationIdRoute: typeof AdminOrganizationsAssignmentsOrganizationIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminInvitationsRoute: AdminInvitationsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStatisticsRoute: AdminStatisticsRoute,
  AdminTasksRoute: AdminTasksRoute,
  AdminWaitingListRoute: AdminWaitingListRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminChallengesSlugRoute: AdminChallengesSlugRoute,
  AdminUsersIdRoute: AdminUsersIdRoute,
  AdminChallengesIndexRoute: AdminChallengesIndexRoute,
  AdminOrganizationsIndexRoute: AdminOrganizationsIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminOrganizationsAssignmentsOrganizationIdRoute:
    AdminOrganizationsAssignmentsOrganizationIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LangRoute: LangRouteWithChildren,
  AboutRoute: AboutRoute,
  AdminRoute: AdminRouteWithChildren,
  AnalyticalWorkflowRoute: AnalyticalWorkflowRoute,
  AssignmentsRoute: AssignmentsRoute,
  FaqRoute: FaqRoute,
  InviteRoute: InviteRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TakeHomeAssignmentsRoute: TakeHomeAssignmentsRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  UserAreaRoute: UserAreaRoute,
  UsingAiWithoutOutsourcingJudgmentRoute:
    UsingAiWithoutOutsourcingJudgmentRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  XpLabFeedbackRoute: XpLabFeedbackRoute,
  AuthGoogleRoute: AuthGoogleRoute,
  AuthInviteRoute: AuthInviteRoute,
  AuthLinkedinRoute: AuthLinkedinRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthSignupRoute: AuthSignupRoute,
  ChallengeSlugRoute: ChallengeSlugRoute,
  ChallengesAvailableRoute: ChallengesAvailableRoute,
  ChallengesCompletedRoute: ChallengesCompletedRoute,
  MySharesChallengeSlugRoute: MySharesChallengeSlugRoute,
  PartnerDashboardRoute: PartnerDashboardRoute,
  PartnerSettingsRoute: PartnerSettingsRoute,
  SubmissionSlugRoute: SubmissionSlugRoute,
  UpdatesSlugRoute: UpdatesSlugRoute,
  UpdatesIndexRoute: UpdatesIndexRoute,
  PartnerCIdRoute: PartnerCIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
